import React, { useContext, useEffect } from "react";
import {
  FaTimes,
  FaCheckCircle,
  FaExclamationTriangle,
  FaTimesCircle,
} from "react-icons/fa";
import { useAlert } from "../../contexts/AlertContext";
import "./LandingAlertComponent.css";
import { CanvasContext } from "../../contexts/CanvasContext";

const AlertComponent = () => {
  const { alert, setAlert } = useAlert();
  const { isDarkTheme } = useContext(CanvasContext);

  useEffect(() => {
    let timer;
    if (alert) {
      timer = setTimeout(() => {
        setAlert(null);
      }, alert.duration);
    }
    return () => clearTimeout(timer);
  }, [alert, setAlert]);

  const handleClose = () => {
    setAlert(null);
  };
  const getIcon = () => {
    switch (alert.variant) {
      case "success":
        return <FaCheckCircle />;
      case "warn":
        return <FaExclamationTriangle />;
      case "error":
        return <FaTimesCircle />;
      default:
        return null;
    }
  };

  return (
    alert && (
      <div
        className={`alert-container ${isDarkTheme ? "dark-theme" : ""} ${
          alert.variant
        }`}
      >
        <div className="alert-content">
          <div className="alert-icon">{getIcon()}</div>
          <div>
            <h3 className="alert-title">{alert.title}</h3>
            <p className="alert-message">{alert.message}</p>
          </div>
          <button className="alert-close-btn" onClick={handleClose}>
            <FaTimes />
          </button>
        </div>
      </div>
    )
  );
};

export default AlertComponent;